module.exports = __webpack_public_path__ + "assets/img/zx_icon.eaa79b27.png";